import React from 'react';
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import TableCell from '@mui/material/TableCell';
import Checkbox from '@mui/material/Checkbox';
import TableRow from '@mui/material/TableRow';
import { Feed } from '../../../../models';
import dayjs from 'dayjs'

import AppLink from '../../../../components/AppLink';
import { ROUTES } from '../../../../history';


const FeedListWidget: React.FC<{
    feed: Feed;
    active?: boolean;
 
   
    onClickCheck?: (p: Feed) => void;

}> = ({ feed, active = false,   onClickCheck }) => {
 
        return (
            <TableRow >
            <TableCell component="th" scope="row">
                    <Box display="flex" alignItems={'center'}>
                        <Box display="inline-block" sx={{
                            mr: 1
                        }}>
                           <Checkbox checked={active} onChange={() => {
                if (onClickCheck) {
                    onClickCheck(feed);
                }
            }} />
                          </Box>
                    <AppLink  doNotUseButton to={ROUTES.ADMIN_BASE + "/feeds/view/" + feed.id}>   <Typography component="span" fontSize="14px" fontWeight={"bold"}>  {feed.title}
                        </Typography>  </AppLink>     </Box>
                </TableCell> 
                <TableCell align="right">
                    {feed.excerpt}
                </TableCell>
                <TableCell align="right">
                    {feed.isActive ? 'Yes' : 'No'}
                </TableCell>
            </TableRow>
        );
 

    
}

export default FeedListWidget
